import trans from '../../../Translations/translation.service';
import { ALL_SELECT_OPTION_M, API_DATE_FORMAT } from '../../../Constants';

export const ACTIVITY_TYPES_SELECT_OPTIONS = [
    ALL_SELECT_OPTION_M,
    {
        text: trans('default.activities.types.apiMessageSent'),
        value: 1,
    },
    {
        text: trans('default.activities.types.campaignDeleted'),
        value: 4,
    },
    {
        text: trans('default.activities.types.campaignScheduled'),
        value: 3,
    },
    {
        text: trans('default.activities.types.campaignSent'),
        value: 0,
    },
    {
        text: trans('default.activities.types.creditsAdded'),
        value: 5,
    },
    {
        text: trans('default.activities.types.testMessageSent'),
        value: 2,
    },
    {
        text: trans('default.activities.types.logIn'),
        value: 6,
    },
    {
        text: trans('default.activities.types.logOut'),
        value: 7,
    },
    {
        text: trans('default.activities.types.scheduledCampaignDeleted'),
        value: 8,
    },
    {
        text: trans('default.activities.types.userCreated'),
        value: 9,
    },
    {
        text: trans('default.activities.types.userDeleted'),
        value: 10,
    },
    {
        text: trans('default.activities.types.accountCreated'),
        value: 11,
    },
    {
        text: trans('default.activities.types.accountDeleted'),
        value: 12,
    },
];

export const ADMIN_REPORTS_FILTERS_INPUTS = [
  {
    id: 'from',
    inputFormat: API_DATE_FORMAT,
    InputLabelProps: {
      shrink: true,
    },
    label: trans('forms.fields.admin.reportsFilters.from'),
    name: 'from_date',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'datepicker',
  },
  {
    id: 'to',
    inputFormat: API_DATE_FORMAT,
    InputLabelProps: {
      shrink: true,
    },
    label: trans('forms.fields.admin.reportsFilters.to'),
    name: 'to_date',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'datepicker',
  },
];

export const ADMIN_ACTIVITIES_FILTERS_INPUTS = [
  {
    id: 'from',
    inputFormat: API_DATE_FORMAT,
    InputLabelProps: {
      shrink: true,
    },
    label: trans('forms.fields.admin.activitiesFilters.from'),
    name: 'from_date',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'datepicker',
  },
  {
    id: 'to',
    inputFormat: API_DATE_FORMAT,
    InputLabelProps: {
      shrink: true,
    },
    label: trans('forms.fields.admin.activitiesFilters.to'),
    name: 'to_date',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'datepicker',
  },
  {
    id: 'account',
    label: trans('forms.fields.admin.activitiesFilters.account'),
    name: 'account_id',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
  {
    id: 'user',
    label: trans('forms.fields.admin.activitiesFilters.user'),
    name: 'user_id',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
  {
    data: ACTIVITY_TYPES_SELECT_OPTIONS,
    id: 'type',
    label: trans('forms.fields.admin.activitiesFilters.type'),
    name: 'type',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
];

export const ADMIN_KEYWORDS_FILTERS_INPUTS = [
  {
    id: 'account',
    label: trans('forms.fields.admin.keywordsFilters.account'),
    name: 'account_id',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
  {
    id: 'short-code',
    label: trans('forms.fields.admin.keywordsFilters.shortCode'),
    name: 'short_code_id',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
  {
    id: 'keyword',
    label: trans('forms.fields.admin.keywordsFilters.keyword'),
    name: 'keyword_id',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
];

export const ADMIN_PAYMENTS_FILTERS_INPUTS = [
    {
      id: 'from',
      inputFormat: API_DATE_FORMAT,
      InputLabelProps: {
        shrink: true,
      },
      label: trans('forms.fields.admin.paymentsFilters.from'),
      name: 'from_date',
      sizes: {
        xs: 12,
        sm: 6,
        md: 2,
      },
      type: 'datepicker',
    },
    {
      id: 'to',
      inputFormat: API_DATE_FORMAT,
      InputLabelProps: {
        shrink: true,
      },
      label: trans('forms.fields.admin.paymentsFilters.to'),
      name: 'to_date',
      sizes: {
        xs: 12,
        sm: 6,
        md: 2,
      },
      type: 'datepicker',
    },
    {
      id: 'account',
      label: trans('forms.fields.admin.paymentsFilters.account'),
      name: 'account_id',
      sizes: {
        xs: 12,
        sm: 6,
        md: 2,
      },
      type: 'select',
    },
    {
      id: 'month',
      label: trans('forms.fields.admin.paymentsFilters.month'),
      name: 'month',
      sizes: {
        xs: 12,
        sm: 6,
        md: 2,
      },
      type: 'select',
    },
    {
      id: 'year',
      label: trans('forms.fields.admin.paymentsFilters.year'),
      name: 'year',
      sizes: {
        xs: 12,
        sm: 6,
        md: 2,
      },
      type: 'select',
    },
];

export const ADMIN_SENT_CAMPAIGNS_FILTERS_INPUTS = [
  {
    id: 'from',
    inputFormat: API_DATE_FORMAT,
    InputLabelProps: {
      shrink: true,
    },
    label: trans('forms.fields.admin.campaignsFilters.from'),
    name: 'from_date',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'datepicker',
  },
  {
    id: 'to',
    inputFormat: API_DATE_FORMAT,
    InputLabelProps: {
      shrink: true,
    },
    label: trans('forms.fields.admin.campaignsFilters.to'),
    name: 'to_date',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'datepicker',
  },
  {
    id: 'account',
    label: trans('forms.fields.admin.campaignsFilters.account'),
    name: 'account_id',
    sizes: {
      xs: 12,
      sm: 6,
      md: 2,
    },
    type: 'select',
  },
];
